import React from 'react';
import { ShieldCheckIcon, ClockIcon, DollarSignIcon } from 'lucide-react';
export function KeyHighlights() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3149">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3150">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-3151">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3152">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-3153">
              <ShieldCheckIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-3154" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3155">
              NRA Program
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3156">
              An official National Rifle Association crime prevention and
              personal safety program.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3157">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-3158">
              <ClockIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-3159" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3160">
              4-Hour Seminar
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3161">
              Learn about home, automobile, phone, technology, personal
              safety—and much more.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3162">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-3163">
              <DollarSignIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-3164" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3165">
              Cost: $50.00
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3166">
              Check the club calendar for upcoming seminar dates and
              availability.
            </p>
          </div>
        </div>
      </div>
    </div>;
}